const state = {
  notificationSnackbar: {
    text: "",
    color: "success",
    trigger: true
  },
  isLoggedIn: false,
  firstLogin: false,
  firstVisit: true,
  conditionsDialogTrigger: true,
  navigationDrawer: {
    trigger: false
  }
};
const getters = {
  notification: state => {
    return state.notificationSnackbar;
  },
  firstLogin: state => {
    return state.firstLogin;
  },
  conditionsDialogTrigger: state => {
    return state.conditionsDialogTrigger;
  },
  isLoggedIn: state => {
    return state.isLoggedIn;
  }
};

const actions = {};

const mutations = {
  firstLogin(state, payload) {
    state.firstLogin = payload;
  },
  firstVisit(state, payload) {
    state.firstVisit = payload;
  },
  isLoggedIn(state, payload) {
    state.isLoggedIn = payload;
  },
  notify(state, payload) {
    Object.keys(payload).forEach(key => {
      state.notificationSnackbar[key] = payload[key];
    });
    state.notificationSnackbar.trigger = !state.notificationSnackbar.trigger;
  },
  openNavigation(state) {
    state.navigationDrawer.trigger = !state.navigationDrawer.trigger;
  }
};

export const viewstate = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
